<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title">Import Products</h4>
  <button
    type="button"
    class="btn btn-link p-0 border-0"
    aria-label="Close"
    (click)="cancel()"
    >
    <i class="bi bi-x-lg"></i>
  </button>
</div>
<div class="modal-body p-3">
  <div class="card">
    <div class="card-header bg-light">
      <div class="d-flex justify-content-between align-items-center">
        <p class="m-0">Import products into the planogram</p>
        <!-- Form to add barcodes -->
        <form (ngSubmit)="addBarcode()" #barcodeForm="ngForm" class="m-0">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              [(ngModel)]="newBarcode"
              name="barcode"
              placeholder="Enter barcode"
              required />
              <button
                class="btn btn-primary"
                type="submit"
                [disabled]="!barcodeForm.form.valid">
                Add
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="card-body">
        <!-- List of barcodes -->
        <div class="barcode-list row">
          @for (barcode of barcodes; track barcode) {
            <div class="badge text-primary d-flex gap-2 align-items-center col-auto border border-dark mx-2 p-2">
              <span class="fs-6 text-dark">{{ barcode }}</span>
              <button
                class="btn btn-sm btn-outline-danger"
                (click)="removeBarcode(barcode)">
                <i class="bi bi-trash"></i>
              </button>
            </div>
          }

          @if (barcodes.length === 0) {
            <div class="text-muted text-center">
              No barcodes added
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="confirm()"
      [disabled]="barcodes.length === 0"
      >
      Import
    </button>
  </div>
